import { useEventBus } from '@vueuse/core'

export const evtBus = useEventBus<'showLoading' | 'closeLoading'>(
  'appRouterView'
)

export type EvtBusType = typeof evtBus

export type EvtBusListenerType = Parameters<EvtBusType['on']>[0]

export const showLoading = () => {
  evtBus.emit('showLoading')
}

export const closeLoading = () => {
  evtBus.emit('closeLoading')
}
